import React, { FunctionComponent, Children, ReactElement } from 'react';

interface Flagged {
  flag: When;
  children: ReactElement | Array<ReactElement>;
}

type When = boolean;

interface Whennable {
  when?: When;
}

const Feature: FunctionComponent<Whennable> = ({ when, children }) => {
  return <>{children}</>;
};
Feature.displayName = 'Feature';

const Stable: FunctionComponent<Whennable> = ({ when, children }) => {
  return <>{children}</>;
};
Stable.displayName = 'Stable';

const Flagged: FunctionComponent<Flagged> = ({ flag, children }) => {
  const visible: any[] = [];

  const isFeature = (child: ReactElement) =>
    //@ts-ignore
    child.type.displayName === Flagged.displayName;
  const isStable = (child: ReactElement) =>
    //@ts-ignore
    child.type.displayName === Stable.displayName;

  Children.forEach(children, (child: ReactElement) => {
    // TODO: This should be refactored to be more readable once
    // we feel good about our unit tests
    if (child.props.when === undefined) {
      // Handle the cases where there is NO when clause
      if (isFeature(child) && flag) {
        // Show FLAGGED when TRUE
        visible.push(child);
      } else if (isStable(child) && !flag) {
        // Show Stable when FALSE
        visible.push(child);
      } else if (!isFeature(child) && !isStable(child) && flag) {
        // Show the element if it's not a STABLE or FLAGGED && TRUE
        visible.push(child);
      } else {
        // Noop
      }
    } else {
      if (child.props.when === flag) {
        // Handle the case when flag matches (is enabled)
        if (isFeature(child)) {
          visible.push(child);
        } else {
          //noop
        }
      } else {
        // When flag is disabled
        if (isStable(child)) {
          visible.push(child);
        } else {
          //noop
        }
      }
    }
  });

  return <>{visible}</>;
};

export { Feature, Stable, Flagged };
